import React, { useEffect, useState } from "react";
import { Container, Card, CardBody, Spinner, Table } from "reactstrap";
import { useRoleContext } from "../../context/RoleContext";
import { getPropertyById } from "../../helpers/firestoreService";

const TenantProperty = () => {
  document.title = "My Property | Porcher";

  const { activeTenant } = useRoleContext();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeTenant?.propertyId) { setLoading(false); return; }
    getPropertyById(activeTenant.propertyId)
      .then(setProperty)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [activeTenant]);

  if (loading) {
    return (
      <div className="page-content d-flex justify-content-center align-items-center" style={{ minHeight: 300 }}>
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <h4 className="mb-4">My Property</h4>
        {!property ? (
          <div className="text-center py-5 text-muted">
            <i className="bx bx-building-house font-size-40 d-block mb-3" />
            <h5>No property linked to your account</h5>
          </div>
        ) : (
          <Card className="border-0 shadow-sm">
            <CardBody>
              <h5 className="mb-3">{property.address}</h5>
              <Table borderless size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td className="text-muted small fw-semibold" style={{ width: "35%" }}>Address</td>
                    <td className="small">{property.address}</td>
                  </tr>
                  {property.notes && (
                    <tr>
                      <td className="text-muted small fw-semibold">Notes</td>
                      <td className="small">{property.notes}</td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default TenantProperty;
